import ch_collection from 'collections/coachhub';
import PermissionModel from 'models/permission';


export default ch_collection.extend({
  url: PERMISSION_API_URL,
  model: PermissionModel
});



// WEBPACK FOOTER //
// ./static/js/collections/permission.js